import { useFeatureFlag } from '@spotify/confidence-flag-evaluation-react';
import { useAccountMode } from '@spotify/confidence-graphql';

export const useIsManagedWarehouse = (): {
  loading: boolean;
  managedWarehouseFlagEnabled: boolean;
  isManagedWarehouse: boolean;
} => {
  const { enabled } = useFeatureFlag<{ enabled: boolean }>(
    'managed-warehouse',
    {
      enabled: false,
    },
  );

  const { loading, hasManagedWarehouse, hasCustomerWarehouse } =
    useAccountMode();

  return {
    loading,
    managedWarehouseFlagEnabled: enabled,
    isManagedWarehouse: enabled && hasManagedWarehouse && !hasCustomerWarehouse,
  };
};
